import i from "./index24.js";
import { resolveComponent as o, openBlock as n, createBlock as s, normalizeClass as r } from "vue";
import "./index25.js";
import u from "../../../../_virtual/index.js";
function p(e, d, l, t, c, f) {
  const a = o("MenuCategory"), m = o("HeaderSignedOut");
  return e.user.isSignedIn ? (n(), s(a, {
    key: 0,
    dropdownMenuItems: e.menuItems,
    menuType: e.isMobile ? e.menuTypes.ExpandOnClick : e.menuTypes.ExpandOnHover,
    name: e.username,
    class: r([
      e.isMobile ? "menu-category-mobile" : "",
      e.showMenuItems ? "" : " hide-dropdown"
    ]),
    hasArrowIcon: !e.isMobile && e.showMenuItems,
    shouldRedirect: !1
  }, null, 8, ["dropdownMenuItems", "menuType", "name", "class", "hasArrowIcon"])) : (n(), s(m, {
    key: 1,
    config: e.config,
    class: r(e.isMobile ? "menu-category-mobile" : "")
  }, null, 8, ["config", "class"]));
}
const h = /* @__PURE__ */ u(i, [["render", p], ["__scopeId", "data-v-acae44f7"]]);
export {
  h as default
};
//# sourceMappingURL=index12.js.map
